import { useFollowTopicMutation, useUnfollowTopicMutation } from "api/topicsApi.slice";
import { useSelector } from "common/utilities/react-redux";
import { useTrack } from "common/utilities/useTrack";
import type { TrackPage } from "domains/analytics/types";
import { getCanFollowTopic } from "entities/permissions/selectors";

type UseTopicFollowingParams = {
  topicId: string;
  topicName: string;
  isFollowing?: boolean;
  pageForTracking?: TrackPage;
  subpageForTracking?: TrackPage;
};

export const useTopicFollowing = ({
  topicId,
  topicName,
  isFollowing,
  pageForTracking,
  subpageForTracking,
}: UseTopicFollowingParams) => {
  const track = useTrack();

  const [followTopic, { isLoading: isFollowLoading }] = useFollowTopicMutation();
  const [unfollowTopic, { isLoading: isUnfollowLoading }] = useUnfollowTopicMutation();

  const canFollow = useSelector(getCanFollowTopic);

  const isFollowingUpdating = isFollowLoading || isUnfollowLoading;

  const toggleFollow = async () => {
    track({
      entityId: topicId,
      entityName: topicName,
      entityType: "Topic",
      name: "Follow",
      page: pageForTracking ?? "Discover",
      subpage: subpageForTracking,
    });
    if (isFollowing) await unfollowTopic({ id: topicId });
    else await followTopic({ id: topicId });
  };

  return { canFollow, isFollowing, isFollowingUpdating, toggleFollow };
};
